<template>
    <modal name="modalKontainer" :draggable="false" :scrollable="true" :height="'auto'">
        <div class="modal fade show " tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true" role="dialog">
            <div class="modal-dialog  modal-xl">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel"> {{ $t("peti_kemas") }} </h5>
                        <button type="button" class="btn btn-default" @click.prevent="removeModals()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>


                    <form class="forms-sample" @submit.prevent="submitData" method="POST" enctype="multipart/form-data">

                        <div class="modal-body">


                            <div class="mb-3">
                                <label for="defaultconfig" class="col-form-label"> {{ $t('seri') }} </label>
                                <input type="text" class="form-control" :id="this.$dynamicId()" :placeholder="$t('seri')"
                                    v-model="form_kontainer.seriKontainer" disabled />
                                <div v-if="errors.seriKontainer">
                                    <div v-for="error in errors.seriKontainer" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="defaultconfig" class="col-form-label"> {{ $t('nomorNya') }} </label>
                                <input type="text" class="form-control" :id="this.$dynamicId()"
                                    :placeholder="$t('nomorNya')" v-model="form_kontainer.nomorKontainer" required
                                    maxlength="255" @input="forceUpper($event, form_kontainer, 'nomorKontainer')" />
                                <div v-if="errors.nomorKontainer">
                                    <div v-for="error in errors.nomorKontainer" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="defaultconfig" class="col-form-label"> {{ $t('ukuran') }} </label>

                                <v-select :options="fetchUkuran" v-model="ukuranKontainer" label="label" return-object>
                                </v-select>

                                <div v-if="errors.kodeUkuranKontainer">
                                    <div v-for="error in errors.kodeUkuranKontainer" :key="error"
                                        class="alert alert-primary" role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="defaultconfig" class="col-form-label"> {{ $t('jenis') }} </label>

                                <v-select :options="fetchJenis" v-model="jenisKontainer" label="label" return-object>
                                </v-select>

                                <div v-if="errors.kodeJenisKontainer">
                                    <div v-for="error in errors.kodeJenisKontainer" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="defaultconfig" class="col-form-label"> {{ $t('type') }} </label>

                                <v-select :options="fetchType" v-model="typeKontainer" label="label" return-object>
                                </v-select>

                                <div v-if="errors.kodeTipeKontainer">
                                    <div v-for="error in errors.kodeTipeKontainer" :key="error" class="alert alert-primary"
                                        role="alert">
                                        <i data-feather="alert-circle"></i>
                                        {{ error }}
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{
                                this.$t("close_txt") }}</button>
                            <button type="submit" class="btn btn-primary">{{ this.$t("save_change_txt") }}</button>
                        </div>

                    </form>

                </div>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    name: "modalKontainer",
    props: {
        docForm: { type: [Object, Array] }
    },
    data() {
        return {
            form_kontainer: [],
            errors: [],

            fetchJenis: [],
            jenisKontainer: null,

            fetchUkuran: [],
            ukuranKontainer: null,

            fetchType: [],
            typeKontainer: null,
        }
    },
    methods: {
        forceUpper(e, obj, prop) {
            const start = e.target.selectionStart
            e.target.value = e.target.value.toUpperCase()
            this.$set(obj, prop, e.target.value)
            e.target.setSelectionRange(start, start)
        },
        removeModals() {
            this.$modal.hide('modalKontainer');
        },
        asyncJenisKontainer() {

            this.fetchJenis = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=100&page=1&type=kodeJenisKontainer&sort_field=code&sort_type=ASC";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;

                    if (models.length > 0) {

                        for (var x = 0; x < models.length; x++) {

                            var ob = models[x];
                            var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
                            this.fetchJenis.push(md);
                        }


                    }



                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },
        asyncTypeKontainer() {

            this.fetchType = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=100&page=1&type=kodeTipeKontainer&sort_field=code&sort_type=ASC";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;

                    if (models.length > 0) {

                        for (var x = 0; x < models.length; x++) {

                            var ob = models[x];
                            var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
                            this.fetchType.push(md);
                        }


                    }



                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },
        asyncUkuranKontainer() {

            this.fetchUkuran = [];
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?limit=100&page=1&type=kodeUkuranKontainer&sort_field=code&sort_type=ASC";

            return this.$http
                .get(
                    baseURI, { timeout: 100000 }
                )
                .then((response) => {

                    var models = response.data.datas.data;

                    if (models.length > 0) {

                        for (var x = 0; x < models.length; x++) {

                            var ob = models[x];
                            var md = { code: ob.code, name: ob.name, label: ob.code + " - " + ob.name }
                            this.fetchUkuran.push(md);
                        }


                    }



                }).catch(error => {

                    if (error.code == "ECONNABORTED") {
                        this.error("Please Check Your Internet Connection");
                    }

                });
        },
        submitData() {
            this.form_kontainer.kodeJenisKontainer = this.jenisKontainer?.code;
            this.form_kontainer.namaJenisKontainer = this.jenisKontainer?.name;

            this.form_kontainer.kodeTipeKontainer = this.typeKontainer?.code;
            this.form_kontainer.namaTipeKontainer = this.typeKontainer?.name;

            this.form_kontainer.kodeUkuranKontainer = this.ukuranKontainer?.code;
            this.form_kontainer.namaUkuranKontainer = this.ukuranKontainer?.name;
            console.log(this.form_kontainer);
            const baseURI = this.$settings.endPointCeisa + "v1/document/store-step-6-peti-kemas";
            this.$http.post(baseURI, this.form_kontainer, { timeout: 100000 }).then((response) => {
                if (response.data.status === 200) {
                    this.isLoading = false;
                    this.errors = [];
                    this.removeModals();
                    this.$emit("setValue");
                    this.form_kontainer = [];
                    this.jenisKontainer = null;
                } else {
                    this.isLoading = false;
                    this.errors = response.data.errors;
                    this.resultError(response.data.errors);
                }
            }).catch(error => {
                this.isLoading = false;
                if (error.code == "ECONNABORTED") {
                    this.error("Please Check Your Internet Connection");
                }

                if (error.response) {
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                        this.logout();
                    } else if (error.response.status === 403) {
                        this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                        this.$router.push('/server-error');
                    } else {
                        this.$router.push('/page-not-found');
                    }
                }
            });
        },
        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.fade(false);
            }, 1000); // hide the message after 3 seconds
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        removeField(index, fieldType) {
            fieldType.splice(index, 1);
        },
    },
    created() {
        this.asyncJenisKontainer();
        this.asyncTypeKontainer();
        this.asyncUkuranKontainer();
    },
    watch: {
        docForm: function (newVal) {
            this.form_kontainer = newVal;
            if (newVal.kodeJenisKontainer == null || newVal.kodeJenisKontainer == "") {
                this.jenisKontainer = null;
            } else {
                this.jenisKontainer = { code: newVal.kodeJenisKontainer, name: newVal.namaJenisKontainer, label: newVal.kodeJenisKontainer + " - " + newVal.namaJenisKontainer };
            }
            if (newVal.kodeTipeKontainer == null || newVal.kodeTipeKontainer == "") {
                this.typeKontainer = null;
            } else {
                this.typeKontainer = { code: newVal.kodeTipeKontainer, name: newVal.namaTipeKontainer, label: newVal.kodeTipeKontainer + " - " + newVal.namaTipeKontainer };
            }
            if (newVal.kodeUkuranKontainer == null || newVal.kodeUkuranKontainer == "") {
                this.ukuranKontainer = null;
            } else {
                this.ukuranKontainer = { code: newVal.kodeUkuranKontainer, name: newVal.namaUkuranKontainer, label: newVal.kodeUkuranKontainer + " - " + newVal.namaUkuranKontainer };
            }
        },
    },
}
</script>

<style></style>